import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ref, get } from "firebase/database";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { auth, firestore, database as realtimeDB } from "../../FirebaseConfig"; // Import Firebase DBs
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import toast from "react-hot-toast";

export default function BestSelling() {
  const [bestSellingProducts, setBestSellingProducts] = useState([]);
  const [bannerDeal, setBannerDeal] = useState("");
  const [bannerTitle, setBannerTitle] = useState("");
  const [bannerDesc, setBannerDesc] = useState("");


  const handleAddToCart = async (product,id) => {
    if (!auth.currentUser) {
      toast.error("Please log in to add items to your cart.");
      // alert("Please log in to add items to your cart.");
      // navigate(`/login?redirect=/`);
      return;
    }

    if (  product.stock<1) {

      return
    }
      ;

    // setAddingToCart(true);
    const userId = auth.currentUser.uid;
    const cartRef = doc(firestore, "customers", userId);
    toast.loading("Adding Item .!");

    try {
      const cartSnap = await getDoc(cartRef);

      if (cartSnap.exists()) {
        const cartData = cartSnap.data();
        let updatedCart = { ...cartData };

        if (updatedCart.items) {
          const existingItemIndex = updatedCart.items.findIndex(item => item.productId === id);

          if (existingItemIndex !== -1) {
            updatedCart.items[existingItemIndex].quantity += 1;
          } else {
            updatedCart.items.push({ productId: id, quantity:1 });
          }
        } else {
          updatedCart = { items: [{ productId: id, quantity:1 }] };
        }

        await updateDoc(cartRef, updatedCart);
      } else {
        await setDoc(cartRef, { items: [{ productId: id, quantity:1 }] });
      }
      toast.dismiss();
      toast.success("Item added to cart!");
    } catch (error) {
      toast.dismiss();

      console.error("Error adding to cart:", error);
      toast.error("Error adding item to cart. Please try again.");
    }

    // setAddingToCart(false);
  };



  useEffect(() => {
    const fetchBestSellingData = async () => {
      const bestSellRef = ref(realtimeDB, "bestSell");
      const snapshot = await get(bestSellRef);

      if (snapshot.exists()) {
        const data = snapshot.val();
        setBannerDeal(data.bannerIcon);

        setBannerDesc(data.bannerDesc);
        setBannerTitle(data.bannerTitle);
        // Fetch product details from Firestore using product IDs
        const productPromises = data.products.map(async (productId) => {
          const productRef = doc(firestore, "products", productId);
          const productSnap = await getDoc(productRef);

          return productSnap.exists() ? { id: productId, ...productSnap.data() } : null;
        });

        const fetchedProducts = (await Promise.all(productPromises)).filter(Boolean);
        setBestSellingProducts(fetchedProducts);
      }
    };

    fetchBestSellingData();
  }, []);


//   .wt-separator {
//     display: block;
//     height: 2px;
//     margin-bottom: 5px !important;
//     margin: auto;
//     position: relative;
//     transition: width 0.3s ease;
//     width: 40px;
//   }
//   .wt-separator2 {
//     display: block;
//     height: 2px;
//     margin: auto;
//     position: relative;
//     transition: width 0.3s ease;
//     width: 60px;
//   }

  

return (
  <div className="m-5">
    <div className="text-center mb-6">
      <h3 className="text-2xl font-bold">Best Sellers</h3>
      <div className="w-16 h-1 bg-orange-500 mx-auto mt-2"></div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      {/* Left Side Banner */}
      <div
        className="bg-cover hidden md:block bg-center h-80 flex items-center justify-center p-6 rounded-md shadow-lg"
        style={{ backgroundImage: `url(${bannerDeal})` }}
      >
        <div className="text-black text-center">
          {/* <h3 className="text-xl font-bold">{bannerTitle}</h3>
          <p className="mt-2">{bannerDesc}</p>
          <Link
            to="/shop"
            className="mt-2 inline-block bg-black p-2 text-orange-500 py-2 rounded-md"
          >
            Shop Now
          </Link> */}
        </div>
      </div>

      {/* Right Side Swiper for Best Selling Products */}
      <div className="col-span-2">
        {bestSellingProducts.length === 0 ? (
          // Shimmer Effect for Loading Products
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {[1, 2].map((index) => (
              <div key={index} className="border rounded-md p-4 bg-white shadow-md animate-pulse">
                <div className="h-40 bg-gray-200 rounded-md"></div>
                <div className="mt-3">
                  <div className="h-4 bg-gray-300 w-3/4 rounded-md"></div>
                  <div className="mt-2 h-4 bg-gray-300 w-1/2 rounded-md"></div>
                </div>
                <div className="mt-4 h-8 bg-gray-400 w-full rounded-md"></div>
              </div>
            ))}
          </div>
        ) : (
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={10}
            slidesPerView={1}
            breakpoints={{
              1024: { slidesPerView: 3 }, // For large screens
              492: { slidesPerView: 2 }, // For medium screens
            }}
            autoplay={{ delay: 2500 }}
            className="rounded-md"
          >
            {bestSellingProducts.map((product) => {
              const actualPrice = product.prices.productPrice;
              const offerPrice = actualPrice - product.prices.productDiscount;
              const discountPercent = (
                (product.prices.productDiscount / actualPrice) *
                100
              ).toFixed(0);

              return (
                <SwiperSlide key={product.id}>
                  <div className="border rounded-md p-2 bg-white shadow-md">
                    <Link to={`/product/${product.id}`} className="block text-center">
                      <img
                        src={product.thumbnail}
                        alt={product.name}
                        className="md:h-45 h-50 object-contain mx-auto"
                      />
                    </Link>
                    <div className="mt-3 text-center">
                      <h4 className="text-md font-semibold">{product.name}</h4>
                      <div className="flex justify-center items-center mt-1 space-x-2">
                        {product.prices.productDiscount > 0 ? (
                          <>
                            <span className="text-lg font-bold text-green-600">₹{offerPrice}</span>
                            <span className="text-sm line-through text-gray-500">₹{actualPrice}</span>
                            <span className="text-sm bg-red-500 text-white px-2 py-1 rounded-md">
                              {discountPercent}% OFF
                            </span>
                          </>
                        ) : (
                          <span className="text-lg font-bold text-gray-800">₹{actualPrice}</span>
                        )}
                      </div>
                      <button
                        onClick={() => handleAddToCart( product,product.id)}
                        className="mt-3 bg-orange-500 font-bold text-white px-4 py-2 rounded-md w-40"
                      >
                        Add to Cart
                      </button>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>
    </div>
  </div>
);

}
